'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _list = require('@/components/list');

var _list2 = _interopRequireDefault(_list);

var _menu = require('./menu');

var _menu2 = _interopRequireDefault(_menu);

var _secondSearch = require('@/components/base/second-search');

var _secondSearch2 = _interopRequireDefault(_secondSearch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    listData: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    title: {
      type: String,
      default: function _default() {
        return this.$t('index.courseCategory');
      }
    },
    iscolor: {
      type: Boolean,
      default: true
    },
    allMenu: {
      type: Object,
      default: function _default() {
        return {
          name: this.$t('index.allCourses'),
          isSelect: true
        };
      }
    },
    loadding: {
      type: Boolean,
      default: true
    },
    breadCateId: {
      default: ''
    },
    showSecondLevel: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      showCas: false,
      levelMenuData: [],
      showAnother: false,
      cascComp: {},
      listArr: [],
      scrollTop: 0
    };
  },

  watch: {
    listData: function listData(newVal, oldVal) {
      if (!this.showSecondLevel) {
        this.listArr = this.listData;
        this.allMenu.id = this.allMenu.id || this.allMenu.id == '' ? this.allMenu.id : this.listData[0].id;
      } else {
        if (this.listData[0]) {
          this.listArr = this.listData[0].children;
          this.allMenu.id = this.allMenu.id || this.allMenu.id == '' ? this.allMenu.id : this.listData[0].id;
        } else {
          this.listArr = [];
          this.allMenu.id = '';
        }
      }
    }
  },
  created: function created() {
    this.cascComp = _menu2.default;
  },
  mounted: function mounted() {
    document.addEventListener('scroll', this.onScroll);
  },
  destroyed: function destroyed() {
    document.removeEventListener('scroll', this.onScroll);
  },
  provide: function provide() {
    return {
      selectLi: this.selectLi,
      hideMenu: this.hideMenu,
      addClassName: this.addClassName
    };
  },

  methods: {
    onScroll: function onScroll() {
      this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
    },

    //全部课程事件
    allClassify: function allClassify() {
      var _this = this;

      var lis = document.querySelectorAll('.menu-li');
      var menus = document.querySelectorAll('menu-two');

      var _loop = function _loop(i) {
        var names = lis[i].className.split(/\s+/);
        if (lis[i].className.indexOf('activeLi') != -1) {
          names.forEach(function (key, ind) {
            if (key == 'activeLi') {
              names[ind] = '';
            }
          });
          _this.$set(_this.listArr[i], 'isSelect', false);
        }
      };

      for (var i = 0; i < lis.length; i++) {
        _loop(i);
      }

      var _loop2 = function _loop2(j) {
        var menuNames = menus[j].className.split(/\s+/);
        if (menus[j].className.indexOf('spanColor') != -1) {
          menuNames.forEach(function (val, menuInd) {
            if (val == 'spanColor') {
              menuNames[menuInd] = '';
            }
          });
          _this.$set(_this.levelMenuData[j], 'isSelect', false);
          if (_this.levelMenuData[j].children.length) {
            _this.levelMenuData[j].children.forEach(function (value, key) {
              _this.$set(_this.levelMenuData[j].children[key], 'isSelect', false);
            });
          }
        }
      };

      for (var j = 0; j < menus.length; j++) {
        _loop2(j);
      }
      this.$set(this.allMenu, 'isSelect', true);
      this.$emit('on-checkAll', this.allMenu);
    },

    //滑过控制二、三级菜单展示
    selectLi: function selectLi(item, parentData) {
      if (item.length) {
        this.showMenu();
        this.levelMenuData = item;
        this.judgeCascading(item);
      } else {
        this.hideMenu();
      }
    },

    //点击选中一级菜单
    addClassName: function addClassName(item, parentData) {
      var all = document.querySelector('.menu-all');
      if (all) {
        var _names = all.className.split(/\s+/);
        if (all.className.indexOf('activeMenu') != -1) {
          _names.forEach(function (item, index) {
            if (item == 'activeMenu') {
              _names[index] = '';
            }
          });
          this.$set(this.allMenu, 'isSelect', false);
        }
      }
      this.$emit('on-check', item, parentData);
      this.immediatelyHide();
    },

    //点击选择二、三级菜单
    checkMenu: function checkMenu(item) {
      var all = document.querySelector('.menu-all');
      if (all) {
        var _names2 = all.className.split(/\s+/);
        if (all.className.indexOf('activeMenu') != -1) {
          _names2.forEach(function (item, index) {
            if (item == 'activeMenu') {
              _names2[index] = '';
            }
          });
          this.$set(this.allMenu, 'isSelect', false);
        }
      }
      this.$emit('on-checkSon', item);
      this.immediatelyHide();
    },

    //判断是否全是二级菜单，没有三级菜单
    judgeCascading: function judgeCascading(currentData) {
      var count = 0;
      for (var i = 0; i < currentData.length; i++) {
        if (!currentData[i].children) {
          count++;
        }
      }
      if (count == currentData.length) {
        this.showAnother = true;
      } else {
        this.showAnother = false;
      }
    },

    //选中二、三级菜单立即隐藏菜单
    immediatelyHide: function immediatelyHide() {
      if (this.enterTimer) {
        clearTimeout(this.enterTimer);
        this.showCas = false;
      }
    },

    //鼠标移出隐藏菜单
    hideMenu: function hideMenu() {
      var _this2 = this;

      if (this.enterTimer) {
        clearTimeout(this.enterTimer);
        this.enterTimer = setTimeout(function () {
          _this2.showCas = false;
        }, 500);
      }
    },

    //鼠标移入显示菜单
    showMenu: function showMenu() {
      var _this3 = this;

      if (this.enterTimer) clearTimeout(this.enterTimer);
      this.enterTimer = setTimeout(function () {
        _this3.showCas = true;
      });
    }
  },
  components: {
    list: _list2.default,
    SecondSearch: _secondSearch2.default
  }
}; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//